class UploadWrapper extends HTMLElement {
  constructor() {
    super();
    console.log("%cUPLOADING", "background:green;color:white;padding:10px");

    this.uploadKitEv = new Event('adduploadkit');
    
    this.inputs = {};

    this.onWaitUploadKit();

    this.addEventListener('adduploadkit', () => {
      this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
        btn.parentElement.querySelector('.uploadkit-attribute-container').dataset['required'] = customUploadOptions[arg].required;
        let proName = btn.dataset['uploaderName'];
        let property = {
          [`_${proName}`]: '',
          [`_${proName} (direct link)`]: ''
        }
        if (customUploadOptions[arg].referImage) {
          const infoIcon = document.createElement('img');
          infoIcon.setAttribute('src', customUploadOptions[arg].infoImage);
          infoIcon.setAttribute('class', 'upload-info-image');

          const referDiv = document.createElement('div');
          referDiv.setAttribute('class', 'upload-refer-image');

          const examplePhotoText = document.createElement('p');
          examplePhotoText.appendChild(document.createTextNode('Example photo:'));

          const referImage = document.createElement('img');
          referImage.setAttribute('src', customUploadOptions[arg].referImage);

          referDiv.appendChild(examplePhotoText);
          referDiv.appendChild(referImage);
          // referImage.setAttribute('class', 'upload-refer-image');
          const labelEl = $(btn).siblings('label').get(0);
          labelEl.lastChild.before(infoIcon);
          labelEl.lastChild.after(referDiv);
        }
        if (customUploadOptions[arg]?.hasTextField) {
          const label = document.createElement('label');  
          const labelName = document.createTextNode(customUploadOptions[arg].textFieldLabel);
          label.appendChild(labelName);
    
          const inputName = document.createElement('input');
          inputName.setAttribute('type', 'text');
          inputName.setAttribute('class', 'pet-name');
          inputName.setAttribute('name', `properties[_${proName}_${customUploadOptions[arg].textFieldSuffix}]`);
          inputName.setAttribute('placeholder', customUploadOptions[arg].textFieldPlaceholder);
          inputName.setAttribute('value', '');
    
          const pet_name = document.createElement('div');
          pet_name.classList.add('pet_name');
    
          pet_name.appendChild(label);
          pet_name.appendChild(inputName);
    
          btn.after(pet_name);
          property[`_${proName}_${customUploadOptions[arg].textFieldSuffix}`] = '';
        }
        
        this.inputs.properties = {...this.inputs.properties, ...property};
      });
      console.log(this.inputs);
    });
  }

  onWaitUploadKit() {
    let uploadkit = setInterval(() => {
      if(this.querySelector('.uploadkit-button')) {
        this.dispatchEvent(this.uploadKitEv);
        clearInterval(uploadkit);
      }
    }, 500);
  }

}
customElements.define('upload-btn-wrapper', UploadWrapper);

let uploadKitInit = setInterval(() => {
  if(UploadKit?.initialized) {
    clearInterval(uploadKitInit);
    const uploadTemplate = window.UploadKit.config.uploaders[0];
    
    for (const index in customUploadOptions) {
      const newUploader = {
        ...JSON.parse(JSON.stringify(uploadTemplate)),
        id: uploadTemplate.id + index,
        name: customUploadOptions[index].name,
        formLabelText: customUploadOptions[index].formLabelText,
        required: false,
        conditions: customUploadOptions[index].conditions
      };
      window.UploadKit.config.uploaders.push(newUploader);
    }
    
    window.UploadKit.init();
  }
}, 100);
